import React from 'react';

export function TriangleIcon({ color = '#e8f524' }: { color?: string }) {
  return (
    <svg
      viewBox="0 0 262 300"
      aria-hidden="true"
      fill={color}
      stroke={color}
      strokeWidth="40"
      strokeLinejoin="round"
    >
      <polygon points="20,20 242,150 20,280" />
    </svg>
  );
}
